module.exports = __webpack_public_path__ + "img/zhuanye-dingbu.6198360b.svg";